/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterTransactionDto } from '../../models/center-transaction-dto';

export interface CenterTransactionControllerFind$Params {
  id: string;
}

export function centerTransactionControllerFind(http: HttpClient, rootUrl: string, params: CenterTransactionControllerFind$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterTransactionDto>> {
  const rb = new RequestBuilder(rootUrl, centerTransactionControllerFind.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterTransactionDto>;
    })
  );
}

centerTransactionControllerFind.PATH = '/api/center-transaction/{id}';
